import { client } from "@services/config";
import {
  DAP,
  DAPService,
  Field,
  FiltersRequest,
  ImportResponse,
  ListResponse,
} from "@gen/dap/v1/dap_pb";
import { Sort } from "./common";
import { Direction } from "@gen/tsam/v1/page_pb";
import { ConversationalModule } from "@gen/agency/v1/agency_pb";

export async function importDAP(
  file: File,
  onProgress: (progress: number) => void,
): Promise<ImportResponse> {
  const fileBuffer = await file.arrayBuffer();
  const fileBytes = new Uint8Array(fileBuffer);
  const res = await client(DAPService).import({
    fileContent: fileBytes,
  });
  onProgress(fileBytes.length);
  return res;
}

export async function getDAPS(
  page: number = 1,
  size: number = 10,
  sort?: Sort,
  filters?: FiltersRequest,
): Promise<ListResponse> {
  let field: Field;
  switch (sort?.field) {
    case "number":
      field = Field.NUMBER;
      break;
    case "firstName":
      field = Field.FIRST_NAME;
      break;
    case "lastName":
      field = Field.LAST_NAME;
      break;
    case "caisseId":
      field = Field.CAISSE_ID;
      break;
    default:
      field = Field.UNSPECIFIED;
      break;
  }

  let direction: Direction;
  switch (sort?.direction) {
    case "asc":
      direction = Direction.ASC;
      break;
    case "desc":
      direction = Direction.DESC;
      break;
    default:
      direction = Direction.UNSPECIFIED;
      break;
  }

  return await client(DAPService).list({
    page: {
      page: page,
      size: size,
    },
    sort: {
      field: field,
      direction: direction,
    },
    filters,
  });
}

export interface DAPResponse {
  dap?: DAP;
  error?: string;
  conversationalModule?: ConversationalModule;
}

export async function getDAP(id: string, name: string): Promise<DAPResponse> {
  const res = await client(DAPService).get({ id, name });
  return {
    dap: res.dap,
    error: res.error,
    conversationalModule: res.conversationalModule,
  };
}

export async function updateDAP(dap: DAP): Promise<DAP> {
  console.log("sending update DAP request", dap);
  const res = await client(DAPService).update({
    dap: {
      number: dap.number,
      tauxPec: dap.tauxPec,
      origin: dap.origin,
      destination: dap.destination,
      transportations: dap.transportations,
      journeysBooked: dap.journeysBooked,
      trainCabinClass: dap.trainCabinClass,
      planeCabinClass: dap.planeCabinClass,
      comment: dap.comment,
      lastName: dap.lastName,
      firstName: dap.firstName,
      companions: dap.companions,
      maxJourneys: dap.maxJourneys,
    },
  });
  if (!res.dap) {
    throw new Error("DAP is undefined");
  }
  return res.dap;
}
